import { request } from '../lib/http'

export function fetchByCompany (company) {
  return request({
    url: `origins-by-company/${company}`,
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: 'origin',
    method: 'get',
    params: queriesParams
  })
}

export function addOrigin (origin) {
  return request({
    method: 'post',
    url: 'origin',
    data: origin
  })
}

export function show (id) {
  return request({
    url: `origin/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `origin/${id}`,
    method: 'patch',
    data
  })
}
